(() => {
  const root = document.querySelector('[data-ab-calc]');
  if (!root) return;
  const cfg = JSON.parse(document.querySelector('[data-calc-cfg]').textContent);
  const $ = (q) => root.querySelector(q);
  const $$ = (q) => [...root.querySelectorAll(q)];
  /* Taal: Nederlands is de standaard, Engels op /en/ (html lang). De verstuurde berekening blijft Nederlands voor Audibling. */
  const EN = /^en\b/i.test(document.documentElement.lang || '');
  const L = (nl, en) => (EN ? en : nl);
  const eurNl = (n) => '€' + n.toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  const eur = EN ? (n) => '€' + n.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',') : eurNl;
  const eur0 = EN ? (n) => '€' + Math.round(n).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') : (n) => '€' + Math.round(n).toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  const esc = (t) => String(t == null ? '' : t).replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
  const val = (n) => (root.querySelector(`input[name="${n}"]:checked`) || {}).value;
  const FLT_NL = { DR: 'DR · algemeen', DM: 'DM · muziek en communicatie', DI: 'DI · bouw en industrie', DIM: 'DIM · impulsgeluid' };
  const FLT_EN = { DR: 'DR · general use', DM: 'DM · music and communication', DI: 'DI · construction and industry', DIM: 'DIM · impulse noise' };
  const FLT = EN ? FLT_EN : FLT_NL;
  const MAT_EN = { 'Hard acryl': 'Hard acrylic', Siliconen: 'Silicone' };
  const tiers = cfg.tiers.filter((t) => t[0] > 0).sort((a, b) => a[0] - b[0]);
  const range = $('[name="people_range"]'), num = $('[name="people"]');
  const qtyField = $('[data-qty-field]'), body = $('[data-body]'), recapEl = $('[data-recap]'), ok = $('[data-calc-ok]');
  const SS_KEY = 'ab-offerte-calc';
  const ss = {
    get: (k) => { try { return window.sessionStorage.getItem(k); } catch (e) { return null; } },
    set: (k, v) => { try { window.sessionStorage.setItem(k, v); } catch (e) { /* geen opslag */ } }
  };
  /* Meten via window.abMeet (assets/ab-meten.js), anders in de wachtrij. Nooit namen, e-mail of telefoon meesturen. */
  const meet = (n, d) => { try { if (typeof window.abMeet === 'function') window.abMeet(n, d || {}); else (window.abMeetQ = window.abMeetQ || []).push([n, d || {}]); } catch (e) { /* niets */ } };
  const formKlaar = (n, d) => {
    let tries = 0;
    const go = () => {
      if (typeof window.abMeetFormulierKlaar === 'function') { window.abMeetFormulierKlaar(n, d); return; }
      if (++tries < 40) { setTimeout(go, 200); return; }
      meet(n, d);
      try { const u = new URL(location.href); u.searchParams.delete('contact_posted'); history.replaceState(history.state, '', u.pathname + u.search + u.hash); } catch (e) { /* niets */ }
    };
    go();
  };
  const klasse = (n) => (n >= 100 ? '100 of meer' : n >= 50 ? '50 tot 99' : n >= 25 ? '25 tot 49' : n >= 10 ? '10 tot 24' : '1 tot 9');
  const mensNl = (n) => (n === 1 ? 'persoon' : 'personen');
  const mens = EN ? (n) => (n === 1 ? 'person' : 'people') : mensNl;
  /* regels van de berekening, in het Nederlands (voor de mail) of in de taal van de pagina */
  const mkLines = (r, en) => [
    [`${r.n} × ${r.pkg.name} (${en ? (MAT_EN[r.mat] || r.mat) : r.mat}, ${(en ? FLT_EN : FLT_NL)[r.flt]})`, r.sub],
    r.disc ? [`${en ? 'Volume discount' : 'Staffelkorting'} ${r.tier[1]}%`, -r.disc] : null,
    r.spare ? [`${r.n} × ${en ? 'spare filter set' : 'reservefilterset'}`, r.spareTot] : null,
    r.fit === 'onsite' ? [en ? 'On-site fitting' : 'Aanmeten op locatie', 0] : [en ? 'Ear impressions at a nearby hearing centre' : 'Aanmeten bij een audicien in de buurt', 0],
  ].filter(Boolean);
  const recapFor = (r, en) => `${r.n} ${en ? (r.n === 1 ? 'person' : 'people') : mensNl(r.n)} · ${r.pkg.name} · ${en ? (MAT_EN[r.mat] || r.mat) : r.mat} · ${(en ? FLT_EN : FLT_NL)[r.flt]} · ${r.fit === 'onsite' ? (en ? 'on-site fitting' : 'aanmeten op locatie') : (en ? 'via a hearing centre' : 'via audicien')}${r.spare ? (en ? ' · spare filters' : ' · reservefilters') : ''}`;

  /* ---------- voorinstelling uit de link: filter, aantal, pakket en branche ---------- */
  let preset = null, branche = '', touched = false;
  try {
    const sp = new URLSearchParams(location.search);
    const p = {};
    const f = (sp.get('filter') || '').trim().toUpperCase();
    if (/^(DR|DM|DI|DIM)$/.test(f) && root.querySelector(`input[name="flt"][value="${f}"]`)) p.filter = f;
    const a = (sp.get('aantal') || '').trim();
    if (/^\d{2,4}$/.test(a) && +a >= 10 && +a <= 9999) p.aantal = +a;
    const pk = (sp.get('pakket') || '').trim().toLowerCase();
    if (pk) { const i = cfg.pkgs.findIndex((x) => String(x.name).toLowerCase() === pk); if (i > -1) p.pakket = i; }
    const br = (sp.get('branche') || '').trim().toLowerCase();
    if (/^[a-z0-9-]{1,30}$/.test(br)) branche = br;
    if (Object.keys(p).length) preset = p;
  } catch (e) { preset = null; }
  if (preset) {
    if (preset.filter) root.querySelector(`input[name="flt"][value="${preset.filter}"]`).checked = true;
    if (preset.aantal) num.value = preset.aantal;
    if (preset.pakket != null) { const r = root.querySelector(`input[name="pkg"][value="${preset.pakket}"]`); if (r) r.checked = true; }
  }
  const brancheNaam = (code) => {
    const m = String(cfg.branches || '').split(/\r?\n/).map((l) => l.split('|').map((x) => x.trim())).find((x) => x[0] === code);
    return m && m[1] ? m[1] : code.replace(/-/g, ' ');
  };
  const pre = $('[data-preset]');
  if (pre && preset && preset.filter) {
    pre.textContent = branche ? String(cfg.preset || '').replace('{branche}', brancheNaam(branche)) : String(cfg.presetFilter || '');
    pre.hidden = !pre.textContent;
  }

  $('[data-tiers]').innerHTML = [[1, 0], ...tiers].map(([f, p], i, arr) => {
    const to = arr[i + 1] ? arr[i + 1][0] - 1 : null;
    return `<div data-tier="${f}"><b>${p ? p + L('% korting', '% discount') : L('Basis', 'Standard')}</b><span>${to ? f + L(' tot ', ' to ') + to : L('vanaf ', 'from ') + f}</span></div>`;
  }).join('');
  $('[data-mat-add]').textContent = cfg.silicone ? '+ ' + eur0(cfg.silicone) : '';
  $('[data-spare]').textContent = cfg.spare ? '+ ' + eur0(cfg.spare) + L(' p.p.', ' per person') : '';

  const calc = () => {
    const n = Math.max(1, parseInt(num.value, 10) || 1);
    const big = n >= +cfg.minTeam;
    let pkg = cfg.pkgs[+val('pkg')] || cfg.pkgs[0] || { name: '-', price: 0 };
    if (pkg.logo && !big) pkg = cfg.pkgs.find((p) => !p.logo) || pkg;
    const flt = val('flt'), mat = val('mat'), fit = n >= +cfg.minTeam ? val('fit') : 'dealer', spare = $('[name="spare"]').checked;
    const tier = tiers.filter((t) => n >= t[0]).pop() || [1, 0];
    const next = tiers.find((t) => n < t[0]);
    const unit = +pkg.price + (+cfg.flt[flt] || 0) + (mat === 'Siliconen' ? +cfg.silicone : 0);
    const unitDisc = unit * (1 - tier[1] / 100);
    const spareTot = spare ? n * +cfg.spare : 0;
    const fee = 0;
    const sub = unit * n, disc = sub - unitDisc * n, ex = unitDisc * n + spareTot + fee;
    return { n, pkg, flt, mat, fit, spare, tier, next, unit, unitDisc, spareTot, fee, sub, disc, ex, inc: ex * 1.21, pp: ex / n };
  };

  let last = null;
  const render = (src) => {
    const r = calc();
    range.value = Math.min(r.n, +range.max);
    range.style.setProperty('--p', ((Math.min(r.n, +range.max) - 1) / (+range.max - 1)) * 100 + '%');
    $$('[data-tier]').forEach((el) => el.classList.toggle('is-on', +el.dataset.tier === r.tier[0] || (r.tier[1] === 0 && el.dataset.tier === '1')));
    $('[data-out="pp"]').textContent = eur(r.pp);
    $('[data-out="disc"]').textContent = r.tier[1] ? L(`incl. ${r.tier[1]}% staffelkorting`, `incl. ${r.tier[1]}% volume discount`) : '';
    const lines = mkLines(r, EN);
    const linesNl = EN ? mkLines(r, false) : lines;
    $('[data-lines]').innerHTML = lines.map(([l, v]) => `<div><span>${l}</span><b>${v === 0 ? L('gratis', 'included') : (v < 0 ? '− ' : '') + eur(Math.abs(v))}</b></div>`).join('');
    $('[data-out="ex"]').textContent = eur(r.ex);
    $('[data-out="inc"]').textContent = eur(r.inc);
    const nudge = $('[data-nudge]');
    if (r.next) {
      const save = r.unit * (r.next[1] - r.tier[1]) / 100;
      const rest = r.next[0] - r.n;
      nudge.innerHTML = EN
        ? `<b>${rest}</b> more ${mens(rest)} for <b>${r.next[1]}% discount</b> (${eur(save)} extra saving per person)`
        : `Nog <b>${rest}</b> ${mens(rest)} tot <b>${r.next[1]}% korting</b> (${eur(save)} extra voordeel per persoon)`;
      nudge.hidden = false;
    } else nudge.hidden = true;
    const small = r.n < +cfg.minTeam;
    const onsite = root.querySelector('input[name="fit"][value="onsite"]');
    onsite.disabled = small;
    if (small) root.querySelector('input[name="fit"][value="dealer"]').checked = true;
    $$('input[name="pkg"]').forEach((i) => { i.disabled = small && cfg.pkgs[+i.value] && cfg.pkgs[+i.value].logo; });
    if (small && cfg.pkgs[+val('pkg')] && cfg.pkgs[+val('pkg')].logo) {
      const basic = $$('input[name="pkg"]').find((i) => !cfg.pkgs[+i.value].logo);
      if (basic) basic.checked = true;
    }
    const kaart = EN
      ? ` You can see where they are on the <a href="${esc(cfg.mapUrl || '/en/pages/find-a-hearing-centre')}">${esc(cfg.mapLabel || 'hearing centre map')}</a>.`
      : ` Waar ze zitten, zie je op de <a href="${esc(cfg.mapUrl || '/pages/advies-aanvragen')}">${esc(cfg.mapLabel || 'audicienkaart')}</a>.`;
    $('[data-fit-note]').innerHTML = EN
      ? (small
        ? `On-site fitting and your own logo are available from ${cfg.minTeam} people. Smaller groups have their ear impressions taken at a partner hearing centre and get our standard logo.${kaart}`
        : (r.fit === 'onsite' ? 'We come to you and take ear impressions for everyone at your workplace.' : `Everyone has their ear impressions taken at a nearby partner hearing centre.${kaart}`))
      : (small
        ? `Aanmeten op locatie en een eigen logo kunnen vanaf ${cfg.minTeam} personen. Kleinere groepen laten zich aanmeten bij een aangesloten audicien en krijgen ons standaardlogo.${kaart}`
        : (r.fit === 'onsite' ? 'Wij komen langs en meten iedereen op jullie locatie aan.' : `Iedereen laat zich aanmeten bij een aangesloten audicien in de buurt.${kaart}`));
    /* logolink onder een pakket volgt filter en materiaal */
    $$('[data-logo-link]').forEach((a) => {
      const h = a.getAttribute('href') || '';
      a.setAttribute('href', h.replace(/ontwerp=AB-[HS](\d+)-(DR|DM|DI|DIM)-/i, (m, k) => `ontwerp=AB-${r.mat === 'Siliconen' ? 'S' : 'H'}${k}-${r.flt}-`));
    });
    const recap = EN ? recapFor(r, true) : `${r.n} ${mens(r.n)} · ${r.pkg.name} · ${r.mat} · ${FLT[r.flt]} · ${r.fit === 'onsite' ? 'aanmeten op locatie' : 'via audicien'}${r.spare ? ' · reservefilters' : ''}`;
    const recapNl = EN ? recapFor(r, false) : recap;
    const used = touched || !!preset;
    if (recapEl && !ok) {
      recapEl.innerHTML = used
        ? `<b>${L('Jouw berekening', 'Your calculation')}</b><span>${recap}</span><strong>${eur(r.ex)} ${L('excl. btw', 'excl. VAT')} · ${eur(r.pp)} ${L('p.p.', 'per person')}</strong>`
        : L('<b>Jouw berekening</b><span>Je hebt de rekenhulp nog niet ingevuld. Dat hoeft ook niet. Vul hieronder het aantal personen in, dan maken we de offerte op maat.</span>',
          "<b>Your calculation</b><span>You haven't used the calculator yet. That's fine. Enter the number of people below and we'll put together a quote for you.</span>");
    }
    const calcLines = [recapNl, ...linesNl.map(([l, v]) => `${l}: ${eurNl(v)}`), `Totaal excl. btw: ${eurNl(r.ex)}`, `Totaal incl. btw: ${eurNl(r.inc)}`, `Per persoon: ${eurNl(r.pp)}`];
    const out = touched ? calcLines : (preset ? ['Rekenhulp niet aangepast, voorinstelling uit de link', ...calcLines] : ['Rekenhulp niet aangepast']);
    if (branche) out.push(`Branche ${branche}`);
    if (body) body.value = out.join('\n');
    if (qtyField && src !== 'field' && used) qtyField.value = r.n;
    last = { r, recap, used };
  };

  const touch = () => {
    if (touched) return;
    touched = true;
    meet('rekenhulp_gebruikt', { branche: branche || '' });
  };
  const inCalc = (el) => !!(el && el.closest && el.closest('.ab-calc__steps'));
  range.addEventListener('input', () => { num.value = range.value; touch(); render(); });
  num.addEventListener('input', () => { touch(); render(); });
  $$('[data-step]').forEach((b) => b.addEventListener('click', () => { num.value = Math.max(1, (parseInt(num.value, 10) || 1) + +b.dataset.step); touch(); render(); }));
  root.addEventListener('change', (e) => { if (inCalc(e.target)) { touch(); render(); } });
  if (qtyField) qtyField.addEventListener('input', () => {
    const v = parseInt(qtyField.value, 10);
    if (v >= 1 && v <= 9999) { num.value = v; render('field'); }
  });
  $('[data-to-form]').addEventListener('click', (e) => { e.preventDefault(); $('#offerte-form').scrollIntoView({ behavior: 'smooth' }); setTimeout(() => root.querySelector('[name="contact[Bedrijf]"]')?.focus({ preventScroll: true }), 600); });

  /* ---------- versturen: gegevens voor de bedankstaat in deze sessie bewaren (geen persoonsgegevens) ---------- */
  const form = body && body.closest('form');
  if (form) form.addEventListener('submit', () => {
    render();
    const r = last.r, n = parseInt(qtyField && qtyField.value, 10) || r.n;
    ss.set(SS_KEY, JSON.stringify({
      id: Date.now(), used: last.used, pakket: (touched || (preset && preset.pakket != null)) ? r.pkg.name : '',
      aantal_klasse: klasse(n), recap: last.used ? last.recap : '', ex: eur(r.ex), pp: eur(r.pp)
    }));
  });

  /* ---------- bedankstaat ---------- */
  if (ok) {
    let rec = null;
    try { rec = JSON.parse(ss.get(SS_KEY) || 'null'); } catch (e) { rec = null; }
    if (recapEl) {
      if (rec && rec.used && rec.recap) recapEl.innerHTML = `<b>${L('Verstuurde berekening', 'Calculation sent')}</b><span>${esc(rec.recap)}</span><strong>${esc(rec.ex)} ${L('excl. btw', 'excl. VAT')} · ${esc(rec.pp)} ${L('p.p.', 'per person')}</strong>`;
      else recapEl.hidden = true;
    }
    const id = rec && rec.id ? String(rec.id) : 'zonder';
    if (/[?&]contact_posted=true/.test(location.search) && ss.get('ab-offerte-gemeten') !== id) {
      ss.set('ab-offerte-gemeten', id);
      formKlaar('offerte_verstuurd', { soort: 'zakelijk_calculator', pakket: rec ? rec.pakket : '', aantal_klasse: rec ? rec.aantal_klasse : '' });
    }
    ok.addEventListener('click', (e) => {
      const a = e.target.closest && e.target.closest('[data-ab-doc]');
      if (a) meet('brochure_download', { document: a.getAttribute('data-ab-doc'), plek: 'bedankt' });
    });
  }
  if (location.hash === '#offerte-form' || document.querySelector('.ab-calc__ok, .ab-calc__err')) $('#offerte-form').scrollIntoView();
  const tips = $$('.ab-calc__info');
  const closeTips = (except) => tips.forEach((b) => { if (b !== except) { b.closest('.ab-calc__pkg').classList.remove('is-tip'); b.setAttribute('aria-expanded', 'false'); } });
  tips.forEach((b) => b.addEventListener('click', (e) => {
    e.preventDefault(); e.stopPropagation();
    const card = b.closest('.ab-calc__pkg'), open = !card.classList.contains('is-tip');
    closeTips(b); card.classList.toggle('is-tip', open); b.setAttribute('aria-expanded', open ? 'true' : 'false');
  }));
  document.addEventListener('click', (e) => { if (!e.target.closest('.ab-calc__info')) closeTips(); });
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeTips(); });
  render();
})();
